export default __webpack_public_path__ + "static/media/info-2.51b0ca68.png";